import { useMemo } from "react";

import { fetchAuthSession, updatePassword } from "@aws-amplify/auth";

import useToast from "./useToast";

const useCognito = () => {
	const { showToast } = useToast();

	const methods = useMemo(
		() => ({
			getCurrentAmplifySession: async () => {
				try {
					return await fetchAuthSession();
				} catch (err) {
					console.error("Error: ", err);
					return null;
				}
			},
			changeUserPassword: async (oldPassword: string, newPassword: string) => {
				try {
					const session = await methods.getCurrentAmplifySession();

					if (session) {
						await updatePassword({
							oldPassword,
							newPassword
						});
						showToast({ text: "Password changed successfully", noIcon: true });
					}
				} catch (err) {
					showToast({ text: "Failed to change password, please try again later" });
					console.error("Error: ", err);
				}
			}
		}),
		[showToast]
	);

	return methods;
};

export default useCognito;
